const VISIT_STORAGE_PREFIX = 'scrambl:release-notes:last-visited'

export const RELEASE_NOTES_VISITED_EVENT = 'scrambl:release-notes:visited'

function resolveUserId(userId?: string | null) {
  if (userId) return userId
  if (typeof window !== 'undefined') {
    return window.localStorage.getItem('currentUserId') || 'anonymous'
  }
  return 'anonymous'
}

export function getReleaseNotesVisitStorageKey(userId?: string | null) {
  return `${VISIT_STORAGE_PREFIX}:${resolveUserId(userId)}`
}

export function getReleaseNotesLastVisitedAt(userId?: string | null) {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(getReleaseNotesVisitStorageKey(userId))
}

export function markReleaseNotesVisited(userId?: string | null) {
  if (typeof window === 'undefined') return null

  const storageKey = getReleaseNotesVisitStorageKey(userId)
  const visitedAt = new Date().toISOString()
  window.localStorage.setItem(storageKey, visitedAt)
  window.dispatchEvent(
    new CustomEvent(RELEASE_NOTES_VISITED_EVENT, {
      detail: { storageKey, visitedAt },
    }),
  )
  return visitedAt
}

export function hasUnseenRelease(
  latestPublishedAt: string | null | undefined,
  lastVisitedAt: string | null | undefined,
) {
  if (!latestPublishedAt) return false

  const publishedTime = new Date(latestPublishedAt).getTime()
  if (!Number.isFinite(publishedTime)) return false
  if (!lastVisitedAt) return true

  const visitedTime = new Date(lastVisitedAt).getTime()
  if (!Number.isFinite(visitedTime)) return true
  return publishedTime > visitedTime
}
